import { createContext, useContext } from 'react'
import { Socket } from 'socket.io-client'

export interface SocketContextType {
	socket: Socket | null
	isConnected: boolean
	emitTripUpdate: (tripId: string) => void
	emitItineraryUpdate: (tripId: string) => void
	joinTrip: (tripId: string) => void
	leaveTrip: (tripId: string) => void
}

export const SocketContext = createContext<SocketContextType | undefined>(undefined)

export const useSocket = (): SocketContextType => {
	const context = useContext(SocketContext)
	if (context === undefined) {
		throw new Error('useSocket must be used within a SocketProvider')
	}
	return context
}
